import axios from "axios";
export default class ApiFunnel {
    static buildQuery(startDate, endDate, filters = {}) {
        const params = new URLSearchParams();
        params.set("startDate", startDate);
        params.set("endDate", endDate);
        Object.keys(filters).forEach(k => {
            const v = filters[k];
            if (v != undefined && v !== "")
                params.set(k, String(v));
        });
        return params.toString();
    }
    static async get(path, startDate, endDate, session_uuid, filters = {}) {
        try {
            const response = await axios.get(`/api/admin/reports/funnel/${path}?${ApiFunnel.buildQuery(startDate, endDate, filters)}`, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return response.data.response;
        }
        catch (e) {
            console.error(`Error in ApiFunnel.${path}`, e);
            return false;
        }
    }
    static GetSummary(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("summary", startDate, endDate, session_uuid, filters);
    }
    static GetTrend(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("trend", startDate, endDate, session_uuid, filters);
    }
    static GetAcquisition(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("acquisition", startDate, endDate, session_uuid, filters);
    }
    static GetAbandonment(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("abandonment", startDate, endDate, session_uuid, filters);
    }
    static GetQuality(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("quality", startDate, endDate, session_uuid, filters);
    }
    static GetLeads(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("leads", startDate, endDate, session_uuid, filters);
    }
    // Returns { count, truncated, xlsLink, csvLink } — links are downloaded via ApiAdmin.GetFiles.
    static GetExport(startDate, endDate, session_uuid, filters = {}) {
        return ApiFunnel.get("export", startDate, endDate, session_uuid, filters);
    }
    static async post(path, body, session_uuid) {
        try {
            const response = await axios.post(`/api/admin/reports/funnel/${path}`, body, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return response.data.response;
        }
        catch (e) {
            console.error(`Error in ApiFunnel.${path}`, e);
            return false;
        }
    }
    static SetLeadStatus(session_uuid, customer_uuid, status, note) {
        return ApiFunnel.post("leads/status", { customer_uuid, status, note }, session_uuid);
    }
    // Sends a single follow-up email (backend-gated by FUNNEL_FOLLOWUP_ENABLED).
    static SendFollowUp(session_uuid, customer_uuid) {
        return ApiFunnel.post("leads/follow-up", { customer_uuid }, session_uuid);
    }
}
